import React from "react";
import "./Footer.css";
import Image from "../../../assets/media/logos/Sundar logo.png";
import Rectangle1 from "../../../assets/Footer/Rectangle 95.png";
import Rectangle2 from "../../../assets/Footer/Rectangle 96.png";
import Rectangle3 from "../../../assets/Footer/Rectangle 97.png";
import {FaFacebookF} from "react-icons/fa"
import {AiOutlineGoogle , AiOutlineTwitter} from "react-icons/ai"

export default function Footer() {
  return (
    <>
      <footer className="footer bg-white text-center text-white">
        <div className="container">
          <div className="row d-flex">
            <div className="col-6 col-md d-flex align-items-start flex-column">
              <h1 className="text-dark fs-3 fw-bold text-start">Resources</h1>
              <ul className="list-unstyled text-small text-start">
                <li>
                  <a className="text-muted" href="#">
                    Blog
                  </a>
                </li>
                <li>
                  <a className="text-muted" href="#">
                    Event
                  </a>
                </li>
                <li>
                  <a className="text-muted" href="#">
                    Resources Center
                  </a>
                </li>
              </ul>
              <h1 className="text-dark fs-3 fw-bold text-start mgTop">
                Services & Support
              </h1>
              <ul className="list-unstyled text-small text-start">
                <li>
                  <a className="text-muted" href="#">
                    About Us
                  </a>
                </li>
                <li>
                  <a className="text-muted" href="#">
                    Careers
                  </a>
                </li>
                <li>
                  <a className="text-muted" href="#">
                    Partners
                  </a>
                </li>
                <li>
                  <a className="text-muted" href="#">
                    Press
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md d-flex align-items-start flex-column">
              <h1 className="text-dark fs-3 fw-bold text-start">Company</h1>
              <ul className="list-unstyled text-small text-start">
                <li>
                  <a className="text-muted" href="#">
                    Professional
                  </a>
                </li>
                <li>
                  <a className="text-muted" href="#">
                    Services
                  </a>
                </li>
                <li>
                  <a className="text-muted" href="#">
                    Contact Support
                  </a>
                </li>
              </ul>
              <h1 className="text-dark fs-3 fw-bold text-start mgTop">
                Legal Documents
              </h1>
              <ul className="list-unstyled text-small text-start">
                <li>
                  <a className="text-muted" href="#">
                    Policy Privacy
                  </a>
                </li>
                <li>
                  <a className="text-muted" href="#">
                    Terms and Conditions
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-md-6 mb-md-0 d-flex flex-column justify-content-start align-items-center">
              <img src={Image} alt="" />
              <p className="text-dark mt-6">
                The objective was to develop an industrial estate where issues
                of industrialists are handled and problems solved through ‘One
                Window’ operation.
              </p>
              <button className="btn mt-0">Contact Us</button>
              <section className="mb-4 mt-3 d-flex align-items-center justify-content-center">
                <div
                  className="btnicon d-flex justify-content-center align-items-center m-1"
                  href="#!"
                  role="button"
                >
                    <FaFacebookF/>
                  {/* <i className="fab fa-facebook-f"></i> */}
                </div>

                <div
                  className="btnicon d-flex justify-content-center align-items-center m-1"
                  href="#!"
                  role="button"
                >
                  {/* <i className="fab fa-twitter"></i> */}
                  <AiOutlineGoogle />
                </div>

                <div
                  className="btnicon d-flex justify-content-center align-items-center m-1"
                  href="#!"
                  role="button"
                >
                  {/* <i className="fab fa-google"></i> */}
                  <AiOutlineTwitter />
                </div>
              </section>
            </div>
          </div>
          <div className="svgdiv">
            <img className="mt-5" src={Rectangle1} alt="" />
            <img className="mt-5" src={Rectangle2} alt="" />
            <img className="mt-5" src={Rectangle3} alt="" />
          </div>
        </div>
      </footer>
    </>
  );
}
